import React from "react";
import StarRating from "../../../../../common/components/StarRating/StarRating";

// interfaces
interface IQuoteTableStarRatingContentProps {
    rating: number;
}

// functions

// rendering
const QuoteTableStarRatingContent: React.FC<IQuoteTableStarRatingContentProps> = (
    props
) => {
    const { rating } = props;

    return <StarRating maxRating={5} rating={rating} id="customerservice" />;
};

export default React.memo(QuoteTableStarRatingContent);
